// extracted by mini-css-extract-plugin
export default {"InfoTitle":"InfoTitle_InfoTitle__XqTNN","HighlightPrimary":"InfoTitle_HighlightPrimary__SpteV","HighlightSecondary":"InfoTitle_HighlightSecondary__KeQsY"};